<template>
  <section class="section section-gray" id="pricing">
    <div class="container text-center fade-in-section">
      <h2 class="section-title">Fair Pricing, Real Value</h2>
      <p class="section-subtitle max-w-3xl">We believe in making career growth accessible. Here's what we're planning.</p>
      
      <div class="pricing-teaser max-w-4xl">
        <div class="pricing-teaser-card">
          <div class="pricing-teaser-icon">🆓</div>
          <h3 class="pricing-teaser-title">Free Tier</h3>
          <p class="pricing-teaser-text">Start practicing immediately with limited scenarios. Perfect for trying things out.</p>
        </div>
        <div class="pricing-teaser-card">
          <div class="pricing-teaser-icon">🚀</div>
          <h3 class="pricing-teaser-title">Pro Plan</h3>
          <p class="pricing-teaser-text">Full access to all scenarios, unlimited badges, and premium portfolio features.</p>
        </div>
        <div class="pricing-teaser-card">
          <div class="pricing-teaser-icon">🏢</div>
          <h3 class="pricing-teaser-title">Enterprise</h3>
          <p class="pricing-teaser-text">Team management, custom scenarios, and advanced analytics for organizations.</p>
        </div>
      </div>
      
      <div class="pricing-cta-box">
        <p class="pricing-cta-text">
          <strong>Early Access Benefit:</strong> Waitlist members get early bird benefits for the first year!
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PricingSection'
}
</script>
